import { useEffect } from "react";

// Fecha um overlay/modal ao pressionar ESC. Padrão canônico (sidebar de detalhe de máquina),
// promovido a hook compartilhado p/ ser o mesmo em toda a plataforma (review agendamento p3).
export function useEscClose(open: boolean, onEsc: () => void, deps: unknown[] = []) {
  useEffect(() => {
    if (!open) return;
    function onKey(e: KeyboardEvent) {
      if (e.key === "Escape") onEsc();
    }
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, ...deps]);
}
